import React, { useState, useEffect } from 'react'
import CardCarrito from '../../Components/Carrito/cardCarrito.component'

import * as constant from '../../global/const';
import { useCounter } from '../../Helpers/useCounter';
import { useSelector } from "react-redux";

import imageCarritoLight from '../../assets/icons/carrito-light.svg';
import imageCarritoSolid from '../../assets/icons/carrito-solid.svg';

const ProgressButton = ({ history, width, percent, carState, setCarState }) => {
    const carrito = useSelector(state => state.carrito.carrito);
    const [value, setValue] = useState(0);
    const {totalAmount} = useCounter()
    let _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {}

    // useEffect(() => {
    //     setValue(percent * width);
    // }, [carrito])

    return (
        <React.Fragment>

            <div className="carrito" onClick={() => {
                let isInicio = (window.location.pathname).includes('inicio');
                if (isInicio && window.scrollY == 0 && !carState) {
                    window.scroll({
                        top: 93,
                        behavior: 'smooth'
                    });
                }
                setCarState(!carState)
            }}>
                <button className="open_carrito carritoDesktop"  ><span>
                    {" $" + new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                    }).format(totalAmount)}
                </span></button>

                <button className="open_carrito carritoMovil" style={{ backgroundImage: `url(${_carrito && Object.keys(_carrito).length === 0 ? imageCarritoLight : imageCarritoSolid})` }}>
                    <span>
                        {" $" + new Intl.NumberFormat("de-DE", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                        }).format(totalAmount)}
                    </span></button>
            </div>
            <CardCarrito
                history={history}
                carState={carState}
                setCarState={setCarState}
                totalAmount={totalAmount}
            // handleClickOutsideSucursal={handleClickOutside}
            />
            {/* <div className="progress-carrito" style={{width: width}}>
                <div className="progress" style={{ width: `${value}px` }}><p>hola</p></div>
            </div> */}
        </React.Fragment>
    )
}

export default ProgressButton